module.exports = __webpack_public_path__ + "static/media/singapore.33363e56.png";